import { MedmalstatusMdl } from './MedmalProposal';
import { policyTypeMdl } from './policyTypeMdl';
export class MedmalProposalModel {

       public ProposalNo: string;
       public  Name: string;
       public TotalPremium: number;
       public Status: string;
       public proposalFileName: string;
       public PolicyCardFileName: string;
       public  PaymentStatus: number;
       public  Mobile: string;
       public Email: string;
       public isUnderWriter: string;
       public  EProposalNo: string;
       public  PaySig: string;
       public  EPayInfo: string;
       public ProductCode: string;
       public ProductDesc: string;
       public ProposalType: string;
       public ProposalDate:string;
       public ProposalExpiryStatus:string;
       public  myProObj: MedmalProposalInfoModel=new MedmalProposalInfoModel() ;
       public transObj: MedmalTransInfoModel =new MedmalTransInfoModel();
       public newPolicyObj: policyTypeMdl = new policyTypeMdl();
       public cancelObj:MedmalCancelProposal  = new MedmalCancelProposal();   
       public  isProposalEdit: boolean;
       public SadadBillNo: string;
       public SadadBillExp: string;
}
export class MedmalProposalInfoModel {

    public EncProposalNo: string;

}
export class MedmalCancelProposal {
    public RegNo: string;
    public ProposalNo: string;
}
export class MedmalTransInfoModel {
    public RegNo: string;
    public ProposalNo: string;

    public InsuredName: string;
    public Premium: string;

    public ProductCode: string;

    public Email: string;
    public Mobile: string;

    public merchantRefNum: string;
    public OLPID: string;

    public TransDate: string;
    public st: MedmalstatusMdl = new MedmalstatusMdl();

    public isUnderwriter: boolean;
    public uploadNo: string;

    public PMethod: string;
    public EProposalNo: string;

    public EPayInfo: string;
    public PaySig: string;

    public IBAN: string;
    public BankCode: string;

    public IBAN1: string;
    public IBAN2: string;
    public IBAN3: string;
    public IBAN4: string;
    public IBAN5: string;
    public IBAN6: string;

}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/MedmalProposalModel.ts